<template>
	<v-col class="ma-0 pa-5 mt-7" cols="12" align="center">
		<v-col class="ma-0 pa-0" cols="12"
			v-if="viewCount == 4">
			<v-row class="ma-0 pa-2" align="center">
				<v-col class="ma-0 pa-0 pr-2" cols="6" align="right">
					<v-col v-for="(item, index) in 2" :key="index" id="camera_4box" class="ma-0 pa-0 mb-4" cols="12">
						<v-col id="camera_select_btn" class="ma-0 pa-0" cols="auto">
							<v-btn width="9rem" height="2rem" class="ma-0 pa-0" 
								id="blue_btn" elevation="0" @click="cameraSelect(index, $event)">
								{{tsg('selectCamera')}}
							</v-btn>
						</v-col>
		  			<v-col id="camera_select_bottom_bar" style="display:none;" class="ma-0 pa-0 ellipsis" cols="12">
              {{'cameraName'}}
		  			</v-col>
					</v-col>
				</v-col>
				<v-col class="ma-0 pa-0 pl-2" cols="6" align="left">
					<v-col v-for="(item, index) in 2" :key="index" id="camera_4box" class="ma-0 pa-0 mb-4" cols="12">
						<v-col id="camera_select_btn" class="ma-0 pa-0" cols="auto">
							<v-btn width="9rem" height="2rem" class="ma-0 pa-0" 
								id="blue_btn" elevation="0" @click="cameraSelect(index+2, $event)">
								{{tsg('selectCamera')}}
							</v-btn>
						</v-col>
		  			<v-col id="camera_select_bottom_bar" style="display:none;" class="ma-0 pa-0 ellipsis" cols="12">
              {{'cameraName'}}
		  			</v-col>
					</v-col>
				</v-col>
			</v-row>
		</v-col>

		<v-col class="ma-0 pa-0" cols="12"
			v-if="viewCount == 9">
			<v-row class="ma-0 pa-0 pl-1 pr-1" align="center">
				<v-col v-for="(item, index) in 3" :key="index" class="ma-0 pa-0 pr-1 pl-1" cols="4">
					<v-col v-for="(item_nest, index_nest) in 3" :key="index_nest" id="camera_9box" 
						class="ma-0 pa-0 mb-2" cols="12">
						<v-col id="camera_select_btn" class="ma-0 pa-0" cols="auto">
							<v-btn width="9rem" height="2rem" class="ma-0 pa-0" 
								id="blue_btn" elevation="0" @click="cameraSelect(index_nest + 3*index, $event)">
								{{tsg('selectCamera')}}
							</v-btn>
						</v-col>
		  			<v-col id="camera_select_bottom_bar" style="display:none;" class="ma-0 pa-0 ellipsis" cols="12">
              {{'cameraName'}}
		  			</v-col>
					</v-col>
				</v-col>
			</v-row>
		</v-col>
		
		<v-col class="ma-0 pa-0" cols="12"
			v-if="viewCount == 16">
			<v-row class="ma-0 pa-2" align="center">
				<v-col v-for="(item, index) in 4" :key="index" class="ma-0 pa-0 pl-1 pr-1" cols="3">
					<v-col v-for="(item_nest, index_nest) in 4" :key="index_nest" id="camera_16box" 
						class="ma-0 pa-0 mb-2" cols="12">
						<v-col id="camera_select_btn" class="ma-0 pa-0" cols="auto">
							<v-btn width="8rem" height="2rem" class="ma-0 pa-0" 
								id="blue_btn" elevation="0" @click="cameraSelect(index_nest + 4*index, $event)">
								{{tsg('selectCamera')}}
							</v-btn>
						</v-col>
		  			<v-col id="camera_select_bottom_bar" style="display:none;" class="ma-0 pa-0 ellipsis" cols="12">
              {{'cameraName'}}
		  			</v-col>
					</v-col>
				</v-col>
			</v-row>
		</v-col>
		<v-col class="ma-0 pa-0 mt-3 mb-7" cols="12">
			<v-row class="ma-0 pa-0" align="center" justify="center">
				<v-btn width="9rem" height="2rem" class="ma-0 pa-0" 
					id="grey_btn" elevation="0" @click="cancel">
					{{t('cancel')}}
				</v-btn>
				<v-btn width="9rem" height="2rem" class="ma-0 pa-0 ml-3" 
					id="blue_btn" elevation="0" @click="makeSplitScreen"
					:loading="createLoading">
					{{t('create')}}
				</v-btn>
			</v-row>
		</v-col>
		<SelectCameraDialog :dialogVisible="selectCameraDialogVisible"
			@selectCamera="selectCameraFunc" @visible="selectCameraDialogVisibleFunc" />
	</v-col>
</template>

<script>
import mixin from '@/mixin';
import $ from 'jquery';
import SelectCameraDialog from '../components/SelectCameraDialog.vue';
export default {
	props: {
		viewCount: { type: Number, default: 4 }
	},
	components: {
		SelectCameraDialog
	},
	mixins: [mixin.common],
	data: () => ({
		unisCustomerCd: '',
		selectCameraDialogVisible: false,
		selectedCamera: null,
		selectedCameraList: [],
    selectedIndex: null,
		createLoading: false,
	}),
	mounted() {
		this.unisCustomerCd = this.$store.getters.getUserunisCustomerCd;
	},
	methods: {
		tsg(t) {
      return this.$t("lang.group." + t);
    },
		cameraSelect(index, event) {
      this.selectCameraDialogVisible = true
      this.selectedIndex = index;
      this.selectedCamera = $(event.currentTarget).parent().parent();
    },
		cancel() {
			this.$emit('cancel', true);
			this.selectedCamera = null;
			this.selectedCameraList = [];
		},
		selectCameraDialogVisibleFunc(visible) {
			this.selectCameraDialogVisible = visible;
		},
		selectCameraFunc(camera) {
			if(camera) {
				if(camera.thumbnail) this.selectedCamera.css({"background-image": 'url(' + camera.thumbnail + ')', "background-size": '100% 100%'});
        else this.selectedCamera.css({"background-image" : 'none'});
			}
			this.selectedCamera.children().eq(0).css({'display': 'none'});
      this.selectedCamera.children().eq(1).html(camera.cameraName);
      this.selectedCamera.children().eq(1).css({'display': 'block'});
			this.selectedCameraList.push({
        'index': this.selectedIndex,
        'contractCd': camera.contractCd,
        'portNo': camera.portNo,
				'thingType': camera.thingType
      });
      this.selectedCameraList = this.selectedCameraList.sort((a,b) => a.index - b.index);
		},
		makeSplitScreen() {
			if(this.selectedCameraList.length == 0) {
				this.showToastMessage(this.tmb('noCameraSelected'));
				return;
			}
			this.createLoading = true;
      let params = {
        unisCustomerCd: this.unisCustomerCd,
        splitName: "名称未設定" + Math.floor(Math.random() * 1001),
        cameras: this.selectedCameraList,
				viewCount: this.viewCount
      };
      this.networkController.addPrivateUserSplitScreen(params)
      .then((res) => {
				console.log(res.data);
				this.createLoading = false;
			  this.$emit('addSuccess', res.data);
      }).catch(error => {
        this.createLoading = false;
      });
		},
	}
}
</script>

<style lang="scss" scoped>
#camera_4box {
	background-color: #4E4E4E;
	border: 1px solid #FFFFFF;
	width: 90%;
	height: 15rem;
	min-width: 30rem;
	min-height: 15rem;
	position: relative;
}
#camera_9box {
	background-color: #4E4E4E;
	border: 1px solid #FFFFFF;
	width: 100%;
	height: 12rem;
	min-height: 12rem;
	position: relative;
}
#camera_16box {
	background-color: #4E4E4E;
	border: 1px solid #FFFFFF;
	width: 100%;
	height: 10rem;
	min-height: 10rem;
	position: relative;
}
#camera_select_btn {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 3;
}
#camera_select_bottom_bar {
  position: absolute;
  bottom: 0%;
  text-align: left;
  padding-left: 1em !important;
  font-size: 0.8em;
  z-index: 3;
  background-color: rgba(0, 0, 0, 0.7);
  color: #A8A8A8;
}
</style>